<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="node.name" label="Name" hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          v-model="property.to"
          label="To"
          type="text"
          hide-details
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.to"
          :drawFlowItems="drawFlowItems"
          :property="'to'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="property.cc"
          label="Cc"
          type="text"
          hide-details
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.cc"
          :drawFlowItems="drawFlowItems"
          :property="'cc'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="property.subject"
          label="Subject"
          type="text"
          hide-details
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.subject"
          :drawFlowItems="drawFlowItems"
          :property="'subject'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-textarea
          v-model="property.body"
          placeholder="Compose email …"
          class="textarea-input overflow-x"
          solo
          hide-details
          rows="5"
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-textarea>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.body"
          :drawFlowItems="drawFlowItems"
          :property="'body'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex pt-0 pb-0">
        <div
          @click="browserFile"
          class="cursor-pointer"
          :class="
            property.attachments.length + tempAttachments.length >= limitFile
              ? 'disabled-div'
              : ''
          "
        >
          <v-icon small class="m-r-5">
            fa-paperclip
          </v-icon>
          <span>Attach up to 3 files</span>
        </div>
        <div>
          <input
            ref="file"
            type="file"
            style="display: none"
            accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .jpg, .png"
            @change="onFilePicked"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="d-inline pt-0">
        <!-- already attachments -->
        <div
          v-for="(attachment, index) in property.attachments"
          :key="`attachment-${index}`"
          class="d-inline-block"
        >
          <v-chip
            class="ma-1"
            @click.stop="
              downloadLink(attachment.mail_attachment_id, attachment.file_name)
            "
            link
            outlined
          >
            <div>{{ shortenFilename(attachment.file_name) }}</div>
            <v-icon
              x-small
              right
              class="pl-3 pr-3"
              @click.stop="removeAttachment(attachment)"
            >
              fa-times
            </v-icon>
          </v-chip>
        </div>
        <!-- temp attachments will be uploaded after saved -->
        <div
          v-for="(file, index) in tempAttachments"
          :key="`temp-${index}`"
          class="d-inline-block"
        >
          <v-chip
            class="ma-1"
            @click.stop="downloadPath(file, file.name)"
            link
            outlined
          >
            <div>{{ shortenFilename(file.name) }}</div>
            <v-icon
              x-small
              right
              class="pl-3 pr-3"
              @click.stop="removeTempAttachment(file)"
            >
              fa-times
            </v-icon>
          </v-chip>
        </div>
      </v-col>
    </v-row>

    <div class="m-t-15">
      <div class="input-title">Settings</div>
      <v-row class="align-center">
        <v-col class="p-b-0" cols="12" sm="6" lg="6">
          <span>Request timeout</span>
        </v-col>
        <v-col class="middle d-flex align-center p-b-0" cols="12" sm="6" lg="6">
          <div>
            <v-text-field
              class="margin0 padding0 width70px"
              v-model="property.setting.timeout"
              hide-details
              dense
              reverse
              type="number"
            ></v-text-field>
          </div>
          <div class="ml-2">seconds</div>
        </v-col>
      </v-row>
      <v-row class="align-center">
        <v-col class="p-b-0" cols="12" sm="6" lg="6">
          <span>Wait for response</span>
        </v-col>
        <v-col class="middle d-flex align-center p-b-0" cols="12" sm="6" lg="6">
          <div class="width70px">
            <v-switch
              class="margin-left"
              v-model="property.setting.await"
              inset
              dense
              hide-details
            ></v-switch>
          </div>
        </v-col>
      </v-row>
    </div>

    <hr class="note-divider" />
    <note-component :node="node" />
    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </div>
</template>

<script>
import _ from 'lodash'

import flowApi from '../../../../../../apis/flow'
import NoteComponent from '../../../components/note'
import Snackbar from '../../../components/snackbar'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    Snackbar,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      prefixAttachmentUrl: `${process.env.VUE_APP_CORE_BACKEND}/api/flow_mail_attachment`,
      tempAttachments: [],
      description: '',
      errorMessageFile: '',
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      limitFile: 3,
      limitSize: 20000000,
      // === use for Intellisense ให้ keyup keyDown ได้ ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ให้ keyup keyDown ได้ ===
    }
  },
  created() {
    this.property = this.node.property
    this.property.tempAttachments = []
  },
  watch: {
    tempAttachments: {
      deep: true,
      handler() {
        this.property.tempAttachments = this.tempAttachments
      }
    }
  },
  methods: {
    async downloadLink(flow_mail_attachment_id, fileName) {
      const apiRes = await flowApi.getMailAttachmentFileUrl(
        flow_mail_attachment_id
      )
      const blob = new Blob([apiRes])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    shortenFilename(filename) {
      if (filename && filename.length > 18) {
        return filename.substr(0, 18) + '...'
      }
      return filename
    },
    removeAttachment(item) {
      const index = this.property.attachments.indexOf(item)
      if (index > -1) {
        this.property.attachments.splice(index, 1)
      }
    },
    downloadPath(file, fileName) {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(file)
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    addTempAttachment(file) {
      this.tempAttachments.push(file)
    },
    removeTempAttachment(item) {
      const index = this.tempAttachments.indexOf(item)
      if (index > -1) {
        this.tempAttachments.splice(index, 1)
      }
    },
    browserFile() {
      this.$refs.file.click()
    },
    onFilePicked(e) {
      this.errorMessageFile = ''
      const files = e.target.files

      if (files[0] !== undefined) {
        const file = files[0]

        if (
          file &&
          file.type &&
          (file.type.toLowerCase().includes('pdf') ||
            file.type.toLowerCase().includes('msword') ||
            file.type.toLowerCase().includes('officedocument') ||
            file.type.toLowerCase().includes('ms-excel') ||
            file.type.toLowerCase().includes('ms-powerpoint') ||
            file.type.toLowerCase().includes('zip') ||
            file.type.toLowerCase().includes('png') ||
            file.type.toLowerCase().includes('jpeg'))
        ) {
          const totalFileSize =
            _.sumBy(this.property.attachments, o => {
              return o.file_size
            }) +
            _.sumBy(this.tempAttachments, o => {
              return o.size
            })
          if (file.size + totalFileSize > this.limitSize) {
            this.snackbar.colorSnackbar = 'error'
            this.snackbar.textSnackbar = 'Attachment must not exceed 20 MB'
            this.snackbar.open = true
            return
          }

          this.addTempAttachment(file)
        } else {
          this.snackbar.colorSnackbar = 'error'
          this.snackbar.textSnackbar = 'File format is not supported'
          this.snackbar.open = true
          return
        }
      }

      e.target.value = ''
    },
    // === use for Intellisense ===
    updateIntellisense(data) {
      this.node.property.number_name = '$' + data
    },
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'to') {
        this.property.to = data
      } else if (property == 'cc') {
        this.property.cc = data
      } else if (property == 'subject') {
        this.property.subject = data
      } else if (property == 'body') {
        this.property.body = data
      }
    }
    // === use for Intellisense ===
  }
}
</script>

<style scoped lang="scss">
.width70px {
  width: 70px;
}
.margin-left {
  margin-left: 30px !important;
}
.width100px {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}
.no-margin-top {
  margin-top: 0px !important;
}
.body-dialog {
  margin: 10px !important;
}
.margin-radio {
  margin-top: 10px;
}

.description {
  word-wrap: break-word;
}
.width90px {
  width: 90px;
  min-width: 90px;
  .v-input {
    margin-bottom: -8px;
  }
}

.disabled-div {
  pointer-events: none;
  opacity: 0.5;
}
</style>
